import { useNavigation } from "@react-navigation/native"
import { StackNavigationProp } from "@react-navigation/stack"
import { FormikRadioButton, Subtitle1, useTheme } from "capsule"
import { Formik, useFormikContext } from "formik"
import React, { useMemo } from "react"
import { useTranslation } from "react-i18next"
import { FlatList, StyleSheet } from "react-native"

import { NewClientOnboardingNS } from "../../features/i18n/constants"
import { NewClientOnboardingParamList } from "../../features/Navigation/types"
import { professions } from "./Constants"

const NewClientProfessionalSelectScreen = () => {
  const { t } = useTranslation(NewClientOnboardingNS)
  const navigation =
    useNavigation<
      StackNavigationProp<NewClientOnboardingParamList, "NewClientProfessionalSelect">
    >()

  const parentFormik = useFormikContext<{ profession?: string }>()

  const {
    colors: {
      surface: { background },
    },
    dimensions: { spacing },
  } = useTheme()

  const s = useMemo(
    () => ({
      container: [
        styles.container,
        {
          backgroundColor: background,
        },
      ],
      contentContainer: {
        backgroundColor: background,
        paddingVertical: spacing * 2,
      },
      radioButton: [
        styles.radioButton,
        {
          paddingHorizontal: spacing * 2,
          marginHorizontal: spacing * 2,
          marginBottom: spacing,
        },
      ],
      label: [
        styles.label,
        {
          paddingLeft: spacing / 2,
        },
      ],
    }),
    [background, spacing],
  )

  const onSubmit = async (values: { profession: string }) => {
    parentFormik.setFieldValue("profession", values.profession)

    navigation.goBack()
  }

  const renderItem = ({ item, setFieldValue, handleSubmit }) => (
    <FormikRadioButton
      name="profession"
      value={item.id}
      textOnly
      onPress={() => {
        setFieldValue("profession", item.id)
        setTimeout(() => handleSubmit(), 100)
      }}
      specificLabel={<Subtitle1>{t(`professionalSelect.${item.labelKey}`)}</Subtitle1>}
      flexDirection="row"
      touchableStyle={s.radioButton}
      testID={`radio_profession_${item.id}`}
    />
  )

  return (
    <Formik initialValues={{ profession: "" }} onSubmit={onSubmit}>
      {({ setFieldValue, handleSubmit }) => (
        <FlatList
          style={s.container}
          data={professions}
          keyExtractor={item => item.id}
          renderItem={({ item }) => renderItem({ item, setFieldValue, handleSubmit })}
          contentContainerStyle={s.contentContainer}
        />
      )}
    </Formik>
  )
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    paddingHorizontal: 16,
    paddingVertical: 8,
  },
  radioButton: {
    height: 60,
    width: "100%",
    alignItems: "center",
    alignSelf: "center",
    justifyContent: "center",
  },
  label: {
    width: "100%",
    flexDirection: "row",
    alignItems: "center",
  },
})

export default NewClientProfessionalSelectScreen
